<template>
    <div class="bindCar">
        <topNav :title="title"></topNav>

        <section class="addCar">
            <van-cell-group class="form_box">
                <div class="ipt ipt_carNum">
                    <i></i><van-field v-model="carNum" clearable placeholder="请输入车牌号码" readonly @click.stop="inputCarNum" />
                </div>
                <div class="ipt ipt_num_list">
                    <i></i><van-field v-model="vin" clearable placeholder="请输入车架号" />
                </div>
            </van-cell-group>
            <div class="btns">
                <van-button type="info" style="margin-bottom: 15px;" @click="addCar()">保存</van-button>
            </div>
        </section>
        <section class="pkey-keyboard"  @click.stop v-bind:class="{keyboard:showKeyBoard}">
          <header class="pkey-header2">
              <label class="pkey-chacelbtn" @touchstart="closewin">重输</label><label class="pkey-okbtn" @touchstart.stop="checkplate()">完成</label>
          </header>

          <section class="pkey-keyscontain">
              <ul>
                  <li v-show="txtboardshow" v-for="(item,index) in cartxt"  :key="index">
                      <span class="check-input" v-show="index==cartxt.length-1" @click.stop @touchstart="txtboardshow=false,numboardshow=true">ABC</span>
                      <label v-for="(items,indexi) in item" v-bind:class="{ bg: items==current }" @touchstart="txtclick(items,indexi,item.length)" :key="indexi">{{items}}</label>
                      <span class="delete" v-show="index==cartxt.length-1"  @touchstart="deletes()"></span>
                  </li>
                  <li v-show="numboardshow" v-for="(item,index) in numtxt" :key="index">
                      <span class="check-input" v-show="index==numtxt.length-1" @touchstart="txtboardshow=true,numboardshow=false">字</span>
                      <label v-for="(items,indexi) in item" v-bind:class="{ bg: items==current }" @touchstart="numclick(items,indexi,item.length)" :key="indexi">{{items}}</label>
                      <span class="delete" v-show="index==numtxt.length-1" @touchstart="deletes()"></span>
                  </li>
                  <li v-show="numboardshow2" v-for="(item,index) in numtxt2" :key="index">
                      <span class="check-input" v-show="index==numtxt2.length-1" @touchstart="txtboardshow=true,numboardshow=false,numboardshow2=false">字</span>
                      <label v-for="(items,indexi) in item" v-bind:class="{ bg: items==current }" @touchstart="numclick(items,indexi,item.length)" :key="indexi">{{items}}</label>
                      <span class="delete" v-show="index==numtxt2.length-1" @touchstart="deletes()"></span>
                  </li>
              </ul>
          </section>

        </section>
        <van-loading class="css_loading" type="spinner" v-show="isLoading" />
        

    </div>
</template>
<script>
    import topNav from "../topnav/topnav";
    import commonInput from "@/components/common/commonInput"
    import { Field,Cell,CellGroup,Button,Toast,Loading } from 'vant';
    import {DETAIL as API} from "@/assets/api";
    
    export default {
        name: 'bindCar',
        components:{
            commonInput,
            topNav,
            Field,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup,
            Button,
            Toast,
            Loading
        },
        data() {
            return {
                title:"车辆绑定",
                carNum: '',
                vin: '',
                current:"",
                isLoading: false,
                showKeyBoard: false,
                txtboardshow:true,
                numboardshow:false,
                numboardshow2:false,
                cartxt:[
                    ['京','津','渝','沪','冀','晋','辽','吉','黑','苏'],
                    ['浙','皖','闽','赣','鲁','豫','鄂','湘','粤','琼'],
                    ['川','贵','云','陕','甘','青','蒙','桂','宁','新'],
                    ['藏','使','领','警','学','港','澳']
                ],
                numtxt:[
                  ['Q','W','E','R','T','Y','U','I','O','P'],
                  ['A','S','D','F','G','H','J','K','L'],
                  ['Z','X','C','V','B','N','M']
                ],
                numtxt2:[
                    ['1','2','3','4','5','6','7','8','9','0'],
                    ['Q','W','E','R','T','Y','U','P'],
                    ['A','S','D','F','G','H','J','K','L'],
                    ['Z','X','C','V','B','N','M']
                ],
            }
        },
        created(){

        },
        methods:{
          addCar(){
              if (this.$store.state.cars.length == 5)  {Toast('车辆绑定数量已达到最大!');return}
              let browserType = this.$store.state.browserType;
              if(browserType !== 'wx' && browserType !== 'al') {Toast('请用微信或者支付宝打开!');return}
              if(!this.carNum) {Toast('请输入车牌号');return}
              if(!this.vin) {Toast('请输入车架号');return}
              
            
              this.isLoading = true;
              let phonenumber = this.$store.state.phonenumber;

              let req = {
                  phonenumber: phonenumber,
                  browserType: browserType,
                  vehicleno: this.carNum,
                  vin: this.vin
              }
              this.$http({
                  method: 'post',
                  url: API.BIND_CAR,
                  data: this.qs.stringify(req),
                  success: function(data){
                    this.isLoading = false;
                    if(data.code == 0){
                      const newCar = {};
                      newCar.vehicleno = this.carNum;
                      this.$store.commit('addCar',newCar);
                      this.vin = '';
                      this.carNum = '';
                      this.$toast({
                        duration: 300, message:'添加成功'
                      });
                      setTimeout(() => {
                        this.$router.replace({name: 'manageCars'});
                        this.$router.go(-1);
                      }, 300);
                    }else{
                        this.$toast({
                            duration: 1200,
                            message: data.msg
                        });
                    }
                  }.bind(this),
                  error: function(error){
                      console.log(error)
                  }
              })
          },
          inputCarNum(){
            this.showKeyBoard = true;
            this.txtboardshow = false;
            this.numboardshow = false;
            this.numboardshow2 = false;
            if (!this.carNum) {
              this.txtboardshow = true
            }else if (this.carNum.length == 1) {
              this.numboardshow = true
            }else{
              this.numboardshow2 = true
            }
          },
          txtclick(txt,indexi,size){
            let existLast = ['使','领', '警', '学', '港', '澳']
            this.carNum = existLast.indexOf(txt) == -1 ? txt : this.carNum + txt;
            this.txtboardshow = false;
            this.numboardshow = true;
          },
          numclick : function(num,indexi,size){
            if (this.carNum.length<8) {
              this.carNum = this.carNum + num;
            }
          },
          closewin(){
              this.carNum = '';
          },
          checkplate(){
            this.showKeyBoard = false;
          },
          deletes(){
            const len = this.carNum.length;
            this.carNum = this.carNum.slice(0,len-1);
          },
        },
        watch:{
          carNum(val,oldVal){
            this.txtboardshow = false;
            this.numboardshow = false;
            this.numboardshow2 = false;
            if (!this.carNum) {
              this.txtboardshow = true
            }else if (this.carNum.length == 1) {
              this.numboardshow = true
            }else{
              this.numboardshow2 = true
            }
          }
        },
        mounted(){
            const dom = document.getElementById("app");
            dom.removeEventListener("click",this.checkplate);
            dom.addEventListener("click",this.checkplate);
        }


    }
</script>
<style lang="less" scoped>
  .form_box{
    /* width: 92%; */
    margin: 10px auto;
    .ipt{
      box-sizing: border-box;
      height: 44px;
      padding-left: 30px;
      position: relative;
      background-color: #fff;
      overflow: hidden;
      i{
        display: block;
        min-width: 1em;
        height: 24px;
        margin-right: 5px;
        position: absolute;
        left: 10px;
        top: 10px;
      }
      .van-cell{
        padding: 0 15px;
        line-height: 44px;
      }
      .btn_getauthcode{
          width: 100px;
          height: 100%;
          position: absolute;
          right: 0;
          top: 0;
          border: none;
          outline: none;
          padding: 0;
          text-align: center;
          line-height: 44px;
      }
      &.ipt_carNum{
        border-bottom: 1px solid #eee;
        i{
          width: 22px;
          left: 7px;
          background: url('../../../static/images/icon_license_plate.png') center no-repeat;
          background-size: contain;
        }
      }
      &.ipt_num_list{
        i{
            width: 22px;
            left: 7px;
          background: url('../../../static/images/icon_number_list.png') center no-repeat;
          background-size: contain;
        }
      }
    }
  }
  .btns{
    padding: 0 15px;
    .van-button{
      border-radius: 3px;
      outline: none;
      border: none;
      width: 100%;
      // height: 100%;
      background-color: #4687f8;
      color: #fff;
    }
    .other{
      line-height: 24px;
      font-size: 14px;
      color: #333;
      &:after{
        content: ' ';
        display: table;
        clear: both;
      }
    }
    .register{
      float: left;
    }
    .forgetPassword{
      float: right;
    }
  }
  
 .pkey-keyscontain li label.bg{
   background: #c3c3c3;
 }
 .pkey-keyscontain li label{
    display: inline-block;
    width: 8.4%;
    background: white;
    margin: 2px 2px;
    padding: 12px 0px;
    border-radius: 5px;
 }
 .pkey-keyscontain{
    background: #D1D5DA;
    padding: 5px 0;
 }
 .pkey-keyboard{
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;
    display: none
 }
 .pkey-keyboard.keyboard{
    display: block;
  }
 .pkey-header2{
    height: 35px;
    line-height: 35px;
    background: #F4F4F6;
 }
 .pkey-chacelbtn{
    width: 45%;
    display: inline-block;
    text-align: left;
 }
 .pkey-okbtn{
    width: 45%;
    display: inline-block;
    text-align: right;
 }
 .check-input{
     display: inline-block;
    padding: 12px 0;
    /* float: left; */
    position: absolute;
    left: 12px;
    top: 2px;
    background: #ABB3BA;
    border-radius: 5px;
    width: 40px;
 }
 .pkey-keyscontain li{
   position: relative;
 }
 .delete{
    width: 40px;
    display: inline-block;
    position: absolute;
    background-color: #ABB3BA;
    right: 12px;
    top: 4px;
    height: 37px;
    border-radius: 5px;
    background-image: url('../../../static/images/backDeleteImg.jpg');
    background-size: 74%;
    background-position: center center;
    background-repeat: no-repeat;
 }
 .css_loading{
   position: fixed;
   left: 0;
   top: 0;
   right: 0;
   bottom: 0;
   margin: auto;
 }
</style>




// WEBPACK FOOTER //
// src/components/my/bindCar.vue